export function normalizeApiErrors(
  error,
  fallbackField = "Erro",
  fallbackMessage = "Tente_novamente_mais_tarde"
) {
  const responseData = error?.response?.data || {};
  const errors = Array.isArray(error)
    ? error
    : Array.isArray(responseData.errors)
    ? responseData.errors
    : [];

  if (errors.length) {
    return errors.map((item) => {
      if (typeof item === "string") {
        return { fieldName: fallbackField, message: item };
      }

      return {
        fieldName: item?.fieldName || item?.field || fallbackField,
        message: item?.message || responseData.message || fallbackMessage,
      };
    });
  }

  return [
    {
      fieldName: fallbackField,
      message: responseData.message || fallbackMessage,
    },
  ];
}
